module.exports = __webpack_public_path__ + "assets/img/14.a05bf12e.png";